import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const LOGOS = [
  { src: "/logo-gms.png", alt: "GMS World", href: "https://gms-world.com/", title: "GMS World" },
  { src: "/logo-lds.png", alt: "LDS Pharma", href: "http://ldspharma.com.pk/", title: "LDS Pharma" },
  { src: "/logo-visole.png", alt: "Visole Pharma", href: "https://visole.net/", title: "Visole Pharma" },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="recruitment-footer">
      <div className="recruitment-footer-inner">

        {/* Company Logos */}
        <div className="recruitment-footer-logos">
          {LOGOS.map((logo, i) => (
            <React.Fragment key={logo.alt}>
              {i > 0 && <span className="recruitment-footer-logo-divider" />}
              <a
                href={logo.href}
                target="_blank"
                rel="noopener noreferrer"
                className="recruitment-footer-logo-link"
                title={logo.title}
              >
                <img src={logo.src} alt={logo.alt} className="recruitment-footer-logo" />
              </a>
            </React.Fragment>
          ))}
        </div>

        {/* Copyright + EOE */}
        <div className="recruitment-footer-center">
          <p className="recruitment-footer-copy">
            &copy; {year} GMS World, LDS &amp; Visole. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
